import { onViewLoad } from "jose_modern/on_view_load";

function init() {
  const otherCheck = document.querySelector("#otherCheck");
  const otherInput = document.querySelector("#otherInput");

  otherCheck.addEventListener("change", () => {
    otherInput.required = otherCheck.checked;
  });

  otherInput.addEventListener("focus", () => {
    otherCheck.checked = true;
  });

  otherInput.addEventListener("change", (e) => {
    if (!e.target.value) {
      otherCheck.checked = false;
      return;
    }
    otherCheck.checked = true;
    otherCheck.value = `Other: ${e.target.value}`;
  });
}

onViewLoad("lab_analysis_requests#new", init);
onViewLoad("lab_analysis_requests#create", init);
